import React from "react";

export const TextDirectionContext = React.createContext<"ltr" | "rtl">("ltr");

export default function useTextDirection() {
    return React.useContext(TextDirectionContext);
}
